import { useState } from 'react';
import { faqs } from '@/mocks/gua';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="container-x py-12 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr]">
        <div className="flex flex-col gap-1.5 lg:sticky lg:top-24 lg:self-start">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">常见问题</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">关于看瓜的常见疑问</h2>
          <p className="mt-1 max-w-md text-sm leading-relaxed text-foreground-700">
            关于时间线怎么读、复盘是否客观、信息如何核实等，这里集中回答大家的疑问。
          </p>
          <a
            href="#about"
            className="mt-3 inline-flex w-fit whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            想进一步了解我们
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div id="faq" className="scroll-mt-24 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border bg-background-100 transition-colors ${
                  open ? 'border-accent-300' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="font-label text-sm font-semibold text-foreground-950 md:text-[15px]">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-800'
                    }`}
                  >
                    <i className={open ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                  </span>
                </button>
                {open && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}